export default {
  web: {
    common: {
      for: "for",
      today: "Today",
      unknown: "Unknown",
      checkout: "Checkout",
      noOdds: "No odds",
    },
    navigation: {
      tools: "Tools",
      getLinematePlus: "Get Linemate+",
      startFreeTrial: "Start free trial",
      downloadLinemate: "Download Linemate",
      profileSettings: "Profile settings",
      closeMyPicks: "Close My Picks",
      offSeason: "{{league}} off-season. See you next season.",
      search: {
        teams: "Teams",
        noResultsFor: "No results found for \"{{searchTerm}}\"",
      },
      toolsMenu: {
        opponentDefensiveRank: "Opponent Defensive Rank",
        startingOpponentPitchers: "Starting Opponent Pitchers",
      },
    },
    toastModal: {
      title: "What's new?",
      items: {
        checkout: "Checkout to your preferred book with My Picks.",
        preferredOdds: "View odds for trends with your preferred odds (available for Linemate+ users).",
      },
      actions: {
        dismiss: "Dismiss",
      },
    },
    carousel: {
      previous: "Previous",
      next: "Next",
    },
  },
};
